import { Injectable, inject } from '@angular/core';

import { CriticalErrorService } from '@frontend/sports/critical-error/feature';
import { SportsProductUtils } from '@frontend/sports/host-app/sports-product/feature/utils';
import { OnAppInit, WINDOW } from '@frontend/vanilla/core';
import { fromEvent } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CriticalErrorBootstrapService implements OnAppInit {
    private criticalErrorService = inject(CriticalErrorService);
    private productUtils = inject(SportsProductUtils);

    onAppInit(): void {
        fromEvent(this._window, 'offline')
            .pipe(this.productUtils.filterSports())
            .subscribe(() => setTimeout(() => this.criticalErrorService.showCriticalError(), 0));

        fromEvent(this._window, 'online')
            .pipe(this.productUtils.filterSports())
            .subscribe(() => setTimeout(() => this.criticalErrorService.hideCriticalError(), 0));
    }

    private readonly _window = inject(WINDOW);
}
